import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IUserProfile } from '../../models';
import { userService } from '../../services/user.service';
import { buildProfileSlug, parseSequenceId } from '../../utils/profileSlug';

export const useUserProfile = (slug: string) => {
  const [profile, setProfile] = useState<IUserProfile | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getUserProfile = async () => {
    if (!slug) return null;
    try {
      setLoading(true);
      const seq = parseSequenceId(slug);
      // slug mới (…-{id}) → tra theo sequenceId; link cũ (email/username) → tra theo username
      const res = seq
        ? await userService.profileUserBySequence(seq)
        : await userService.profileUserByUsername(slug);
      const data = res?.data;
      setProfile(data || null);

      // Canonical hoá URL: ƯU TIÊN đường dẫn tuỳ chỉnh (username dạng sạch a-z0-9_ 3-30);
      // nếu chưa có custom thì về slug {tên}-{id} (ẩn email khỏi URL). Link cũ vẫn không vỡ.
      // CHỈ chạy khi đang ở đúng trang /user/:id — vì hook này còn được dùng để FETCH hồ sơ
      // ở nơi khác (vd tab "Bạn bè" nhúng trong /profile); nếu không chặn sẽ rớt /profile?tab=friend.
      if (data && location.pathname.startsWith('/user/')) {
        const uname = (data.username || '').toLowerCase();
        const clean = /^[a-z0-9_]{3,30}$/.test(uname);
        const canonical = clean
          ? uname
          : data.sequenceId
          ? buildProfileSlug(data.fullname, data.sequenceId)
          : '';
        if (canonical && canonical !== slug) {
          // Giữ query (vd ?tab=hop-tac từ sàn hợp tác) khi đổi sang đường dẫn chuẩn.
          navigate(`/user/${canonical}${location.search}`, { replace: true });
        }
      }
      return data;
    } catch {
      setProfile(null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  return {
    loading,
    profile,
    getUserProfile,
  };
};
